import './NumberPicker.scss';

import { InputNumber, Space } from 'antd';
import type { SizeType } from 'antd/es/config-provider/SizeContext';
import { DEFAULT_DECIMAL_PLACES } from 'helpers/mathHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface NumberPickerProps {
  id?: string;
  placeholder?: string;
  value?: number | null;
  min?: number;
  max?: number;
  integer?: boolean;
  size?: SizeType;
  disabled?: boolean;
  className?: string;
  step?: number;
  onChange: (value: number | null) => void;
  suffix?: React.ReactNode;
  parser?: (value?: string) => number;
  addonAfter?: React.ReactNode;
  precisison?: number;
  controls?: boolean;
}

type InputNumberElement = React.ElementRef<typeof InputNumber>;

const NumberPicker = React.forwardRef<InputNumberElement, NumberPickerProps>((props, ref) => {
  const { tCommon } = useCustomTranslation();
  const { addonAfter, controls, className, integer, precisison, ...inputProps } = props;

  const inputClassName = `NumberPicker${!controls ? ' hidden-controls' : ''}${
    !addonAfter && className ? ` ${className}` : ''
  }`;

  const input = (
    <InputNumber
      {...inputProps}
      ref={ref}
      className={inputClassName}
      decimalSeparator={tCommon('decimalSeparator')}
      precision={precisison ?? DEFAULT_DECIMAL_PLACES}
      formatter={(value) =>
        integer && value ? parseInt(value.toString(), 10).toString() : value?.toString() || ''
      }
      controls={controls}
    />
  );

  if (!addonAfter) {
    return input;
  }

  return (
    <Space.Compact block className={`NumberPickerCompact${className ? ` ${className}` : ''}`}>
      {input}
      <div className="ant-input-group-addon NumberPicker-addonAfter">{addonAfter}</div>
    </Space.Compact>
  );
});

export default NumberPicker;
